import { CardContent, type CardContentProps } from "@mui/material";
import { mergeSxProps } from "@src/appV2/redesign/system/ui-components";

// Works for both highlighted and regular visit cards
export function VisitCardContentWrapper(props: CardContentProps) {
  const { sx, ...restProps } = props;

  return (
    <CardContent
      sx={mergeSxProps(
        {
          position: "relative",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          gap: 6,
          minHeight: "100%",
        },
        sx
      )}
      {...restProps}
    />
  );
}
